import { withStyles } from '@material-ui/core/styles';
import { USER_LIST_TITLE } from '../../libraries/texts';
import UserService from '../../services/user-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service: UserService, title: USER_LIST_TITLE, name: 'USER' })
);
